import { Button, Drawer } from "antd";
import secureIcon from "./../../../../assets/images/secure.svg";
import { LangSpecificMsg } from "../../utils/constants";
import { ValidLanguages } from "../../utils/types";
import { useLocation } from "react-router-dom";

export const ConfirmSubmitPopup = ({
  handleSubmitToDoctor,
  isSubmitLoading,
  closePopup,
}: any) => {
  const location = useLocation();
  const { state } = location;
  const selectedLanguage = state?.selectedLang || "english";

  const LangSpecificMsgData =
    LangSpecificMsg[(selectedLanguage as ValidLanguages) || "english"];
    
  return (
    <Drawer
      placement="bottom"
      closeIcon={false}
      open={true}
      height="auto"
      className="rounded-t-2xl overflow-hidden p-0 max-w-[450px] mx-auto"
      push={false}
    >
      <div className="font-semibold text-lg pb-2">
        {LangSpecificMsgData.submitToDoctor}
      </div>
      <div className="text-base pt-1">
        {LangSpecificMsgData.submitToDoctorInfo1}
      </div>
      <div className="text-base pb-2">
        {LangSpecificMsgData.submitToDoctorInfo2}
      </div>
      <section className="flex justify-center flex-col gap-5 mt-6 w-full text-base font-medium tracking-normal leading-loose text-center">
        <button
          className={`flex justify-center overflow-hidden gap-2 self-stretch px-14 py-2 bg-[#ed8a000a] whitespace-nowrap rounded-xl border border-[#ED8A0033] border-solid text-[#ED8A00]`}
          aria-label={"No, I want to add/edit details "}
          onClick={closePopup}
        >
          {LangSpecificMsgData.noAddEditDetails}
        </button>

        <Button
          className={`flex justify-center overflow-hidden gap-2 self-stretch px-14 py-2 text-white bg-indigo-600 whitespace-nowrap rounded-xl border border-indigo-600 border-solid w-full h-[50px] text-base font-medium`}
          aria-label={"Submit to Doctor"}
          onClick={handleSubmitToDoctor}
          loading={isSubmitLoading}
        >
          {LangSpecificMsgData.submitToDoctor}
        </Button>
        <div className="flex gap-2 justify-center opacity-40 mix-blend-luminosity">
          <img src={secureIcon} alt="secure-icon" />
          <div className="text-xs text-[#454551]">
            Your Data is Secured & only doctor can access it
          </div>
        </div>
      </section>
    </Drawer>
  );
};
